import React from 'react';

import classNames from 'classnames';

import { Skeleton } from '@/components/Skeleton';
import { FormattedMessage } from '@/helpers/formatted-message';

import './ConfidenceModuleList.scss';

type ItemProps = { children: React.ReactNode; first?: boolean; last?: boolean };

const Item = ({ children, first = false, last = false }: ItemProps) => (
  <div className={classNames('mainList', { first, last })}>
    <div className="circle__one">
      <div className="circle__two" />
    </div>
    <div className="description">{children}</div>
  </div>
);

const ConfidenceModuleListSkeleton = () => (
  <div className="ConfidenceModule">
    <h3 className="title">
      <FormattedMessage defaultMessage="Plan with confidence" id="PreCheckout.NeedToKnow.heading" />
    </h3>
    <Item first>
      <Skeleton inline width="200px" />
      <Skeleton inline width="100px" />
      <Skeleton inline width="200px" />
    </Item>
    <Item>
      <Skeleton inline width="200px" />
      <Skeleton inline width="100px" />
      <Skeleton inline width="200px" />
    </Item>
    <Item>
      <Skeleton inline width="200px" />
      <Skeleton inline width="100px" />
      <Skeleton inline width="200px" />
    </Item>
    <Item last>
      <Skeleton inline width="200px" />
      <Skeleton inline width="100px" />
      <Skeleton inline width="200px" />
    </Item>
  </div>
);

export default ConfidenceModuleListSkeleton;
